import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/entities/utils';
import { EntityType } from 'store/entities/types';
import { EventStatisticsEntity } from './types';
import * as actions from './actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<EventStatisticsEntity>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const adminEventStatisticsReducer = createReducer<State, Actions>(initialState, {
  [actions.getAdminEventStatistics.request.type]: actionsHandlers.handleGetOneRequest,
  [actions.getAdminEventStatistics.success.type]: actionsHandlers.handleGetOneSuccess,
  [actions.getAdminEventStatistics.failure.type]: actionsHandlers.handleGetOneFailure,
  [actions.getAdminEventStatistics.reset.type]: actionsHandlers.handleGetOneReset,
});

export default adminEventStatisticsReducer;
